import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  align-self: center;
  background-color: ${({ theme }) => theme.colors.red6};
`;
